import { ISourcingRun } from '../types'
import { COMPLETED_IMPORT_STATUSES } from './effectiveSelectedRun'

/**
 * "This run's import COMPLETED but it sourced nobody" (BRAND-9582, QA item 3).
 * The BE has no status for this — `complete_import!` fires unconditionally,
 * with no `creators.any?` guard (repro: brief 38525) — so the FE derives it
 * from `counts`, the same per-run tally `computeVibeCheckProgress` already
 * reads. Gated on the COMPLETED statuses so an `importing` run (more
 * creators still coming) or a `failed`/`expired` run (own dedicated copy)
 * is never mislabelled as an empty result.
 */
export const isCompletedWithNoCreators = (run: ISourcingRun): boolean => {
  if (!COMPLETED_IMPORT_STATUSES.has(run.status)) return false
  const { pending, approved, rejected, ready_for_shortlist: readyForShortlist } = run.counts
  return pending + approved + rejected + readyForShortlist === 0
}
